var React = require('react');

function ChatInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 9H6.01M10 9H10.01M14 9H14.01M19 9C19 13.4183 14.9706 17 10 17C8.46073 17 7.01172 16.6565 5.74467 16.0511L1 17L2.39499 13.28C1.51156 12.0423 1 10.5743 1 9C1 4.58172 5.02944 1 10 1C14.9706 1 19 4.58172 19 9Z","stroke":"url(#paint0_linear_90_10)","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_90_10","x1":"1","y1":"17","x2":"21.5","y2":"1","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#69D994","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#46C9F7","key":1})]))]);
}

ChatInline.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = ChatInline;

ChatInline.default = ChatInline;
